module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/80.fabe7628.png";